import { ReactElement } from 'react';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BalanceIcon from '@mui/icons-material/Balance';
import BlockIcon from '@mui/icons-material/Block';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CloudIcon from '@mui/icons-material/Cloud';
import DescriptionIcon from '@mui/icons-material/Description';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import LaunchIcon from '@mui/icons-material/Launch';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import MailIcon from '@mui/icons-material/Mail';
import PersonIcon from '@mui/icons-material/Person';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { SvgIconTypeMap } from '@mui/material';

/**
 * Get Mui Icon based on legacy app icon name.
 * @param iconName icon name
 * @param iconProps Mui Icon component props
 * @returns Mui Icon component
 */
export const getIcon = (
  iconName?: string | null,
  { sx = [], ...restIconProps }: SvgIconTypeMap['props'] = {},
) => {
  const iconProps: SvgIconTypeMap['props'] = {
    fontSize: 'small',
    ...restIconProps,
    // NOTE: Passing sx props docs - https://mui.com/system/the-sx-prop/#passing-sx-prop
    sx: [{ opacity: 0.6 }, ...(Array.isArray(sx) ? sx : [sx])],
  };

  const iconComponent: { [k: string]: ReactElement<any, any> | undefined } = {
    'icons-file-pen': <DescriptionIcon {...iconProps} />,
    'icon-external-link': <LaunchIcon {...iconProps} />,
    'icons-new-copy2': <FileCopyIcon {...iconProps} />,
    'icons-briefcase': <BusinessCenterIcon {...iconProps} />,
    'icon-dollar': <AttachMoneyIcon {...iconProps} />,
    'icons-chart': <EqualizerIcon {...iconProps} />,
    'icons-library': <LibraryBooksIcon {...iconProps} />,
    'icons-calendar': <EventNoteIcon {...iconProps} />,
    'icon-envelope': <MailIcon {...iconProps} />,
    'icon-cog': undefined,
    'icon-wrench': undefined,
    'icon-user': <PersonIcon {...iconProps} />,
    'icon-calendar': <EventAvailableIcon {...iconProps} />,
    'icon-off': <PowerSettingsNewIcon {...iconProps} />,
    'icon-balance': <BalanceIcon {...iconProps} />,
    'icon-cloud': <CloudIcon {...iconProps} />,
  };

  return iconName
    ? iconComponent[iconName] || <BlockIcon {...iconProps} />
    : undefined;
};
